import { useAppSelector } from 'app/hooks';
import { useEffect, useRef } from 'react';
import { loadStructureAttachments } from 'utils/data';

// Refresh interval: 8 minutes (480000ms)
// This provides a 2-minute buffer before the 10-minute S3 presigned URL expiration
const REFRESH_INTERVAL_MS = 8 * 60 * 1000;

export default function StructureAttachmentsRefreshWatcher() {
  const { structureId, structureAttachments } = useAppSelector(
    (state) => state.structure
  );
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (structureId && structureAttachments.length > 0) {
      intervalRef.current = setInterval(async () => {
        try {
          console.log('Refreshing structure attachment URLs...');
          await loadStructureAttachments(structureId);
          console.log('Structure attachment URLs refreshed successfully');
        } catch (error) {
          console.error('Failed to refresh structure attachment URLs:', error);
        }
      }, REFRESH_INTERVAL_MS);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [structureId, structureAttachments.length]);

  return null;
}
